import { useHRRContext } from '../../context'
import { Demo, Herring } from './components'

export const QuestionnaireForm = () => {
  const { data } = useHRRContext()
  const { showQuestionnaireDemo, showQuestionnaire1 } = data
  if (!showQuestionnaireDemo && !showQuestionnaire1) {
    return null
  }

  return (
    <>
      {showQuestionnaireDemo && <Demo />}
      {showQuestionnaire1 && <Herring />}
    </>
  )
}
